export enum TransactionTypes{
    MoneyIn = 1, 
    MoneyOut = 2, 

}